import html2canvas from 'html2canvas';

const MAX_SIZE_MB = 0.95;
const TARGET_SIZE_MB = 0.9;
const MIN_QUALITY = 0.1;
const QUALITY_DECREMENT = 0.05;

// Helper function to calculate size of base64 string in MB
const getBase64SizeInMB = (base64String) => {
  // Remove data URL prefix to get only base64 string
  const base64WithoutPrefix = base64String.split(',')[1];
  // Calculate size: base64 string length * 3/4 (base64 ratio) / 1024^2 (to MB)
  return (base64WithoutPrefix.length * 3) / 4 / (1024 * 1024);
};

export const captureScreenshot = async () => {
  try {
    const originalScroll = window.scrollY;
    window.scrollTo(0, 0);
    await new Promise((resolve) => setTimeout(resolve, 500));

    const canvas = await html2canvas(document.body, {
      ignoreElements: (element) => {
        return (
          element.classList.contains('navbar') ||
          element.classList.contains('sidebar') ||
          element.classList.contains('sidenav') ||
          element.classList.contains('offcanvas') ||
          element.classList.contains('offcanvas-backdrop')
        );
      },
      removeContainer: true,
      height: document.documentElement.scrollHeight,
      windowHeight: document.documentElement.scrollHeight,
    });

    window.scrollTo(0, originalScroll);

    // Start with maximum quality
    let quality = 1.0;
    let dataUrl = canvas.toDataURL('image/png');
    let currentSize = getBase64SizeInMB(dataUrl);

    // If size is already acceptable, return the image
    if (currentSize <= MAX_SIZE_MB) {
      return dataUrl;
    }

    // Convert to JPEG and reduce quality until we get below target size
    while (currentSize > TARGET_SIZE_MB && quality > MIN_QUALITY) {
      quality -= QUALITY_DECREMENT;
      dataUrl = canvas.toDataURL('image/jpeg', quality);
      currentSize = getBase64SizeInMB(dataUrl);
    }

    // If we couldn't get below target size even with minimum quality,
    // return the smallest version we could create
    return dataUrl;
  } catch (error) {
    console.error('Screenshot failed:', error);
    return null;
  }
};

